import { useAppSelector } from '@shared/lib/redux'

import { navbarStore } from './navbar.slice'

export const useIsNavbarCollapsed = () => {
  return useAppSelector(navbarStore.selectors.selectIsPannelCollapsed)
}
